module.exports = __webpack_public_path__ + "static/img/harry-potter-and-the-chamber-of-secrets.5ab26e9c.jpg";